import React from 'react';
import Slides from './Slideshow';

function App() {
  return <Slides />
};

export default App;
